import { render, staticRenderFns } from "./department-manag.vue?vue&type=template&id=440584ac&"
import script from "./department-manag.vue?vue&type=script&lang=js&"
export * from "./department-manag.vue?vue&type=script&lang=js&"
import style0 from "./department-manag.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports